import React, { useRef } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
  Badge,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import SearchableSingleSelectDropdown from "../../../../../common/SearchableDropdown";
import MultilineTextBox from "../../../../../common/MultilineTextBox";
import {
  addUploadRecordHeader,
  downloadZipFileForHeader,
  fetchDocumentTypeListForReviewer,
  getDownloadFileForPopUpDetails,
  getRecordHeaderdetails,
  updateUploadRecordHeader,
} from "../../../../../services/UploadRecordsApi";
import TextInput from "../../../../../common/TextInput";
import Snackbar from "../../../../../common/Snackbar";
import OverlayDrawer from "../../../../../common/OverlayDrawer";
import DataTable from "../../../../../common/DataTable";
import moment from "moment";
import Loader from "../../../../../common/Loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../redux/Store";
import AccordionComponent from "../../../../../common/Accordion";
import { fetchSenderListForTODO } from "../../../../../services/CaseInformationApi";
import {
  setIsUploadFile,
  setIsCancelFiles,
} from "../../../../../redux/slice/CaseHeaderSlice";
import { GENERAL_LOG_HEADERS } from "../../../../Case_Management/Case_Information/actions/Constant";
import HistorianRecordEditableTable from "../../../Historian/components/HistorianRecordEditableTable";
import {
  REVIEW_HISTORY_HEADERS,
  REVIEW_RECORD_HEADERS,
} from "../../actions/constants";
import RORDataTable from "./RORDataTable";
import {
  GetReviewerRecordList,
  GetReviewerRecordSummaryList,
  GetReviewerRORStatusUpdateList,
  getRORRecordsEmail,
} from "../../../../../services/RecordReviewerAPI";
import { getAppointmentListByCase } from "../../../../../services/ScheduleAppointmentApi";
import UploadStatusFloatingIcon from "../../../../../common/UploadStatusFloatingIcon";

interface SelectedRowData {
  actions: { Edit: string };
  additionalComments: string;
  caseInfoId: number;
  caseRecordHeaderId: number;
  documentCategory: string;
  documentTypeId: number;
  documentTypeName: string;
  fileAction: number;
  headerCreatedBy: string;
  headerCreatedDate: string;
  headerModifiedByName: string;
  headerUpdatedDate: string;
  responseCode: number;
  responseMessage: string;
  totalNoOfFiles: number;
}

interface UploadRecordProps {
  caseInfoId: number;
  userData: any;
  loggedInUserid: number | null;
  onCancel: (action: string) => void;
  selectedRowData: SelectedRowData | null;
  onTabChange: any;
  recordActiveTab: string;
  isRowActionTriggered: boolean;
  activeTab: string;
  isEditorFile?: boolean;
  isRORCompleted?: boolean;
}

interface PartyOption {
  value: string;
  label: string;
  partyCode: string;
}

const RORUploadRecord: React.FC<UploadRecordProps> = ({
  caseInfoId,
  userData,
  loggedInUserid,
  selectedRowData,
  isRowActionTriggered,
  onCancel,
  recordActiveTab,
  activeTab,
  onTabChange,
  isEditorFile = false,
  isRORCompleted = false,
}) => {
  const [documentTypeOptions, setDocumentTypeOptions] = useState<
    {
      value: string;
      label: string;
      documentCategory: string;
      documentTypeDescription: string;
    }[]
  >([]);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null,
  );
  const [documentTypeName, setDocumentTypeName] = useState<string>("");
  const [documentCategory, setDocumentCategory] = useState<string>("");
  const [documentTypeDescription, setDocumentTypeDescription] =
    useState<string>("");
  const [senderOptions, setSenderOptions] = useState<PartyOption[]>([]);
  const [appointmentDateOptions, setAppointmentDateOptions] = useState<any[]>(
    [],
  );
  const [sender, setSender] = useState<string | null | number>(null);
  const [appointmentDateTime, setAppointmentDateTime] = useState<
    string | null | number
  >(null);
  const [senderCode, setSenderCode] = useState<string>("");
  const [comments, setComments] = useState<string>("");
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [snackbarMessage, setSnackbarMessage] = useState<string>("");
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});
  const [error, setError] = useState<string>("");
  const [fileIds, setFileIds] = useState<string[]>([]);
  const [provisionalIdsNew, setProvisionalIdsNew] = useState<any>([]);
  const [result, setResult] = useState<any>({});
  const [reviewHistoryResult, setReviewHistoryResult] = useState<any>({});
  const [logdata, setLogdata] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [showModalROR, setShowModalROR] = useState<boolean>(false);
  const [pendingSaveAction, setPendingSaveAction] = useState<boolean>(false);
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState<boolean | undefined>(
    false,
  );
  const [parentCaseRecordDetailsId, setParentCaseRecordDetailsId] = useState<
    null | number
  >(null);

  const [reviewRecordSummaryResult, setReviewRecordSummaryResult] = useState<
    any[]
  >([]);
  const [recordLists, setRecordLists] = useState<{ [key: string]: any[] }>();
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [selectedRowsByCategory, setSelectedRowsByCategory] = useState<{
    [category: string]: any[];
  }>({});

  const { isUploadFile } = useSelector((state: RootState) => state.caseHeader);
  const dispatch = useDispatch();
  const [isAllCancel, setIsAllCancel] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const [showUploadWarning, setShowUploadWarning] = useState(false);
  const [isOnSaveDisable, setIsOnSaveDisable] = useState<boolean>(false);
  const [senderName, setSenderName] = useState<string>("");

  const fetchHeaderData = async () => {
    try {
      setIsOnSaveDisable(false);
      if (selectedRowData?.caseRecordHeaderId) {
        setLoading(true);
        const data = await getRecordHeaderdetails(
          selectedRowData?.caseRecordHeaderId,
        );

        const firstRecord = data?.result?.[0];
        if (firstRecord) {
          setDocumentType(firstRecord.documentTypeId || null);
          setDocumentTypeName(firstRecord.documentTypeName || "");
          setDocumentCategory(firstRecord.documentCategory || "");
          setAppointmentDateTime(
            String(firstRecord?.subjectQMEScheduleID) || null,
          );
          setSender(String(firstRecord.senderKeyId) || null);
          setSenderCode(firstRecord.senderKeyCode || "");
          setSenderName(firstRecord.senderKeyName || "");
          setDocumentTypeDescription(firstRecord.documentTypeDescription || "");
          setParentCaseRecordDetailsId(firstRecord.parentCaseRecordDetailsId);
          setComments(firstRecord.additionalComments || "");
          setResult(data?.result || {});
          setLogdata([
            {
              createdDate: moment(firstRecord.headerCreatedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              modifiedDate: moment(firstRecord.headerModifiedDate).format(
                "MM/DD/YYYY | HH:mm",
              ),
              createdByName: firstRecord.headerCreatedByName,
              modifiedByName: firstRecord.headerModifiedByName,
            },
          ]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await fetchDocumentTypeListForReviewer();
        setDocumentTypeOptions(data || []);
        const partiesList = await fetchSenderListForTODO(caseInfoId);
        const appointmentList = await getAppointmentListByCase(caseInfoId);
        setSenderOptions(partiesList || []);
        setAppointmentDateOptions(appointmentList || []);
        setAppointmentDateTime(String(userData?.subjectQmeScheduleId));
        const selectedDocType = data?.find(
          (item: any) => item.label === "Preliminary Record Review Summary",
        );
        if (
          selectedDocType &&
          userData?.rorStatus === "Draft Review" &&
          !selectedRowData?.caseRecordHeaderId
        ) {
          setDocumentType(selectedDocType?.value || null);
          setDocumentTypeName(selectedDocType?.label || "");
          setDocumentCategory(selectedDocType?.documentCategory || "");
          setDocumentTypeDescription(
            selectedDocType?.documentTypeDescription || "",
          );
        }
        const selectedParty = partiesList?.find(
          (item: any) => item.value === String(loggedInUserid),
        );
        if (selectedParty && isEditorFile) {
          setSender(selectedParty.value || null);
          setSenderCode(selectedParty?.partyCode || "");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    if (!selectedRowData?.caseRecordHeaderId) {
      fetchHeaderData();
      fetchRORListData();
    }
  }, []);

  useEffect(() => {
    if (!isRowActionTriggered) {
      resetData();
    }
  }, [recordActiveTab, activeTab]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      fetchHeaderData();
      fetchRORListData();
    }
  }, [selectedRowData]);

  const fetchRORListData = async () => {
    try {
      const reviewRecordSummaryData = await GetReviewerRecordSummaryList(
        caseInfoId,
        userData?.subjectQmeScheduleId,
      );

      const reviewHistoryData = await GetReviewerRORStatusUpdateList(
        userData?.subjectQmeScheduleId,
      );

      const resultList = reviewRecordSummaryData?.result ?? [];

      setReviewRecordSummaryResult(resultList);
      setReviewHistoryResult(reviewHistoryData?.result || []);

      if (resultList?.length > 0) {
        const allKeys = resultList.map((_, index) => index.toString());
        setActiveKeys(allKeys);

        const recordListPromises = resultList.map((item) =>
          GetReviewerRecordList(
            caseInfoId,
            Number(item.keyID),
            userData?.subjectQmeScheduleId,
          ).then((res) => ({
            category: item.dataCategory,
            data: res?.result || [],
          })),
        );

        const allRecordLists = await Promise.all(recordListPromises);
        const recordMap: Record<string, any[]> = {};
        allRecordLists.forEach(({ category, data }) => {
          recordMap[category] = data;
        });

        setRecordLists(recordMap);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const resetData = () => {
    const selectedAppointment =
      appointmentDateOptions && appointmentDateOptions?.length > 0
        ? appointmentDateOptions[0]?.value
        : null;
    setAppointmentDateTime(String(userData?.subjectQmeScheduleId));
    setDocumentType(null);
    setDocumentCategory("");
    setSender(null);
    setSenderCode("");
    setDocumentTypeDescription("");
    setComments("");
    setFileIds([]);
    setProvisionalIdsNew([]);
    setParentCaseRecordDetailsId(null);
    setResult({});
  };

  const isRORCompletedWithStatus =
    !!selectedRowData?.caseRecordHeaderId && isRORCompleted;

  const existsSender =
    !!selectedRowData?.caseRecordHeaderId &&
    !!sender &&
    !senderOptions?.some((opt) => opt.value === sender);

  const validateForm = () => {
    const errors = [];
    const allSelectedRowsNew = Object.values(selectedRowsByCategory).flat();
    const invalidPagesReviewed = allSelectedRowsNew?.some(
      (row) =>
        row.caseRecordDetailsID &&
        (row.pagesReviewed === 0 ||
          row.pagesReviewed === "" ||
          row.pagesReviewed == null ||
          row.pagesReviewed == undefined),
    );
    if (!documentType) {
      errors.push("Document Type is mandatory.");
    }

    if (!sender) {
      errors.push("Sender is mandatory.");
    }

    if (documentType && !fileIds?.length) {
      errors.push("Please add at least one record.");
    }

    if (invalidPagesReviewed) {
      errors.push("Pages Reviewed cannot be less than 1 for selected records.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmitForROR = async () => {
    setShowModalROR(true);
    setPendingSaveAction(true);
  };

  const allSelectedRowsValues = Object.values(selectedRowsByCategory).flat();
  const previousRowsValues = Object.values(recordLists || {}).flat();
  const isPagesReviewedChanged = allSelectedRowsValues.some((row) => {
    const prev = previousRowsValues.find(
      (p: any) =>
        Number(p.caseRecordDetailsID) === Number(row.caseRecordDetailsID),
    );

    if (!prev) return false;

    return Number(prev.pagesReviewed) !== Number(row.pagesReviewed);
  });

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setIsOnSaveDisable(true);
    setLoading(true);
    const existCaseRecordHeaderId = selectedRowData?.caseRecordHeaderId;
    const allSelectedRows = Object.values(selectedRowsByCategory).flat();
    const caseRecordDetailsIDs = allSelectedRows
      ?.map((row) => row.caseRecordDetailsID)
      ?.filter((id) => id != null && id !== "")
      .join(",");

    const pagesReviewedValues = allSelectedRows
      ?.map((row) => row.pagesReviewed || 0)
      .join(",");
    const payloadAdd = {
      caseInfoId: caseInfoId,
      documentTypeId: documentType || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: fileIds.join(", ") || "",
      senderKeyId: Number(sender) || null,
      senderKeyCode: senderCode || "",
      subjectQmeScheduleId: Number(appointmentDateTime) || null,
      caseRecordDetails_Csv: caseRecordDetailsIDs || "",
      pageReviewed_Csv: pagesReviewedValues || "",
      detailsComments_Csv: "",
      createdBy: loggedInUserid,
    };
    const payloadUpdate = {
      caseRecordHeaderId: selectedRowData?.caseRecordHeaderId,
      caseInfoId: caseInfoId,
      documentTypeId: documentType || null,
      additionalComments: comments?.trim() || "",
      provisionalIds: provisionalIdsNew || "",
      senderKeyId: Number(sender) || null,
      senderKeyCode: senderCode || "",
      subjectQmeScheduleId: Number(appointmentDateTime) || null,
      caseRecordDetails_Csv: caseRecordDetailsIDs || "",
      pageReviewed_Csv: pagesReviewedValues || "",
      detailsComments_Csv: "",
      createdBy: loggedInUserid,
      modifiedBy: loggedInUserid,
    };
    try {
      let response;
      if (existCaseRecordHeaderId) {
        response = await updateUploadRecordHeader(payloadUpdate);
      } else {
        response = await addUploadRecordHeader(payloadAdd);
      }

      if (response?.isSuccess) {
        const shouldUploadButtonDisable =
          documentName === "Record Review Summary";
        setSnackbarMessage(
          existCaseRecordHeaderId
            ? "Records updated successfully."
            : "Records added successfully.",
        );
        setError("success");
        if (documentName == "Record Review Summary") {
          const emailResponse = await getRORRecordsEmail(
            Number(appointmentDateTime),
          );
        }
        setSnackbarOpen(true);
        setTimeout(() => {
          onTabChange(shouldUploadButtonDisable);
        }, 1000);
      } else {
        setSnackbarMessage(response?.message || "Failed to process record.");
        setError("error");
        setSnackbarOpen(true);
        setIsOnSaveDisable(false);
      }
    } catch (error) {
      console.error("Error processing record:", error);
      setSnackbarMessage("An error occurred while processing the record.");
      setSnackbarOpen(true);
      setError("error");
      setIsOnSaveDisable(false);
    } finally {
      setLoading(false);
      setIsOnSaveDisable(false);
    }
  };
  const handleFileIdsUpdate = (
    ids: string[],
    isSaveDisabled?: boolean,
    fileActions?: any,
  ) => {
    setProvisionalIdsNew(fileActions);
    setFileIds(ids);
    setIsSaveDisabled(isSaveDisabled);
  };

  const handleBack = () => {
    if (isUploadFile) {
      setShowUploadWarning(true);
    } else {
      setShowUploadWarning(false);
      onCancel("Cancel");
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };
  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleCloseModalROR = () => {
    setShowModalROR(false);
    setPendingSaveAction(false);
  };

  const handleConfirmRORChanges = () => {
    setShowModalROR(false);
    handleSubmit();
  };

  const handleConfirmCancelButton = async () => {
    setIsCancel(true);
    if (selectedRowData?.caseRecordHeaderId) {
      await fetchHeaderData();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const handleSaveStateChange = (disabled: boolean) => {
    setIsSaveDisabled(disabled);
  };

  const [recordInfoKey, setrecordInfoKey] = useState<string | null>("0");
  const [documentName, setDocumentName] = useState("");

  useEffect(() => {
    if (documentType) {
      const found = documentTypeOptions.find(
        (doc) => doc.value === documentType,
      );
      if (found) {
        setDocumentName(found.label);
      }
    }
  }, [documentType]);

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
      setDocumentName("");
    }
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  const lastOpenedRef = useRef<number | null>(null);

  useEffect(() => {
    if (!documentType && !sender) return;

    const handleScroll = () => {
      if (lastOpenedRef.current && Date.now() - lastOpenedRef.current < 300) {
        return;
      }

      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  const existsDocType = isRORCompletedWithStatus
    ? true
    : !!selectedRowData?.caseRecordHeaderId &&
      !!documentType &&
      !documentTypeOptions?.some((opt) => opt.value === documentType);

  const recordInfoAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          recordInfoKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}{" "}
              <span className="fw-normal">
                {existsDocType
                  ? documentTypeName && ` - ${documentTypeName} `
                  : documentName && ` - ${documentName} `}
              </span>
            </>
          ),
      }))}
      activeKey={recordInfoKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now();
        setrecordInfoKey(key as string);
      }}
    />
  );

  const [attachmentKey, setattachmentKey] = useState<string | null>("0");
  const [rorKey, seRORKey] = useState<string | null>("0");
  const [recordHistoryKey, setRecordHistoryKey] = useState<string | null>("");

  useEffect(() => {
    if (reviewRecordSummaryResult?.length) {
      const allKeys = reviewRecordSummaryResult.map((_, index) =>
        index.toString(),
      );
      setActiveKeys(allKeys);
    }
  }, [reviewRecordSummaryResult]);

  const attachmentAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={attachmentKey}
      onSelect={(key) => setattachmentKey(key as string)}
    />
  );

  const recordRORAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={rorKey}
      onSelect={(key) => {
        seRORKey(key as string);
      }}
    />
  );

  const recordHistoryAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={recordHistoryKey}
      onSelect={(key) => setRecordHistoryKey(key as string)}
    />
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!isUploadFile) return;
      const target = event.target as HTMLElement;
      // Check if the element or its parent has a "pointer" cursor
      const hasPointerCursor = (element: HTMLElement | null): boolean => {
        while (element) {
          const style = window.getComputedStyle(element);
          if (style.cursor === "pointer") return true;
          element = element.parentElement;
        }
        return false;
      };

      const isButton =
        target.tagName === "BUTTON" ||
        target.closest("button") ||
        target.classList.contains("btn") ||
        target.closest(".btn");

      const isTab =
        target.classList.contains("tab") ||
        target.closest(".tab") ||
        target.classList.contains("nav-link") ||
        target.closest(".nav-link");

      const isInteractiveElement =
        isButton ||
        isTab ||
        target.closest("a.nav-link") ||
        target.closest("[role='tab']") ||
        target.closest("input") ||
        target.closest("label") ||
        target.closest("select") ||
        target.closest("a") ||
        target.closest("[data-ignore-click-outside]") ||
        target.closest('[data-actionable="true"]') ||
        hasPointerCursor(target);

      // NEW: Check if the click is inside a modal or message element
      const isInModalOrMessage =
        target.closest(".modal") ||
        target.closest(".toast") ||
        target.closest(".alert") ||
        target.closest("[role='alert']") ||
        target.closest("[aria-live='polite']");

      const isCancelUploadButton = target.closest("#cancel-upload-button");
      const isInsideDrawer = Boolean(target.closest("#log-overlay-drawer"));
      const isInsideContainer =
        containerRef.current && containerRef.current.contains(target);
      // Check if click is outside the container
      const isOutside = !(
        isInsideContainer ||
        isCancelUploadButton ||
        isInsideDrawer
      );

      if (isOutside && !isInModalOrMessage) {
        if (isInteractiveElement) {
          setShowUploadWarning(true);
        } else {
          setShowUploadWarning(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isUploadFile]);

  const handleUploadInteraction = () => {
    setShowUploadWarning(false);
    dispatch(setIsUploadFile(false));
    dispatch(setIsCancelFiles(true));
    setIsAllCancel(true);
  };

  const handleCloseModalWarning = () => {
    setShowUploadWarning(false);
  };

  useEffect(() => {
    if (selectedRowData?.caseRecordHeaderId) {
      setrecordInfoKey(null);
    } else {
      setrecordInfoKey("0");
    }
    setIsAllCancel(false);
  }, [selectedRowData?.caseRecordHeaderId, recordActiveTab]);

  useEffect(() => {
    const handleScroll = () => {
      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);

      if (documentType && sender) {
        setrecordInfoKey(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [recordInfoKey, documentType, sender]);

  const fetchRecordListDataNew = async (
    caseInfoId: number,
    KeyId: number,
    dataCategory: string,
  ) => {
    try {
      const listData = await GetReviewerRecordList(
        caseInfoId,
        KeyId,
        userData?.subjectQmeScheduleId,
      );
      setRecordLists((prev) => ({
        ...prev,
        [dataCategory]: listData?.result || [],
      }));
    } catch (error) {
      console.error("Error fetching record list data:", error);
    }
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip",
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleHeaderFileDownloadAction = async (
    datacategory: string,
    keyID: any,
  ) => {
    const listDataNew = await GetReviewerRecordList(
      caseInfoId,
      keyID,
      userData?.subjectQmeScheduleId,
    );
    const newIDs =
      listDataNew?.result?.map((item) => item.caseRecordHeaderID).join(",") ||
      "";
    handleDownloadProgress(`doc-${Date.now()}`, () =>
      downloadZipFileForHeader(newIDs, 1, ""),
    );
  };

  const handleDownloadSingleFile = (row: any) => {
    handleDownloadProgress(`popup-${Date.now()}`, () =>
      getDownloadFileForPopUpDetails(row?.caseRecordDetailsID, row?.fileName),
      row?.fileName,
    );
  };

  const handlePagesReviewedChange = (rows: any[], category?: string) => {
    if (category) {
      setSelectedRowsByCategory((prev) => ({
        ...prev,
        [category]: rows,
      }));
    }
  };

  const handleCheckboxSelect = (category: string, selectedRows: any[]) => {
    setSelectedRowsByCategory((prev) => ({
      ...prev,
      [category]: selectedRows,
    }));
  };

  const renderAccordion = () => (
    <AccordionComponent
      items={reviewRecordSummaryResult.map(
        (
          {
            dataCategory,
            totalRecords,
            lastUploadedBy,
            lastUploadedOn,
            keyID,
            categoryWiseTotalPageCount,
          },
          index,
        ) => ({
          title: (
            <div className="d-flex align-items-center w-100">
              <div className="me-auto d-flex align-items-center w-60">
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>{dataCategory}</Tooltip>}
                >
                  <span className="text-truncate w-50">{dataCategory} </span>
                </OverlayTrigger>

                <Badge bg="primary" className="ms-2 primary-badge ">
                  {totalRecords}
                </Badge>
                {categoryWiseTotalPageCount != null && (
                  <>
                    <span className="ms-3 material-icons theme-color">
                      auto_stories
                    </span>
                    <span
                      className="ms-1 theme-color mx-1 fw-light"
                      style={{ width: "55px", textAlign: "left" }}
                    >
                      Pages -{" "}
                    </span>
                    <span className="text-muted">
                      {categoryWiseTotalPageCount}
                    </span>
                  </>
                )}
              </div>
              <div className="fw-normal accord-righttext me-3">
                <div className="d-flex align-items-center justify-content-end">
                  <span
                    className="me-2"
                    style={{ width: "100%", display: "inline-flex" }}
                  >
                    <span
                      style={{
                        width: "81%",
                        marginTop: "5px",
                        display: "inline-block",
                        textAlign: "right",
                        paddingRight: "10px",
                      }}
                    >
                      Last Uploaded On:{" "}
                      {new Date(lastUploadedOn).toLocaleDateString(
                        "en-US",
                      )}{" "}
                    </span>
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{lastUploadedBy}</Tooltip>}
                    >
                      <span
                        className="theme-color text-truncate"
                        style={{
                          width: "50%",
                          float: "right",
                          marginTop: "5px",
                        }}
                      >
                        {" "}
                        | {lastUploadedBy}{" "}
                      </span>
                    </OverlayTrigger>
                  </span>
                  <Button
                    variant="primary"
                    size="sm"
                    className="d-flex align-items-center me-2 px-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleHeaderFileDownloadAction(dataCategory, keyID);
                    }}
                  >
                    <span className="material-icons">download</span>
                  </Button>
                </div>
              </div>
            </div>
          ),
          content: (
            <>
              <div>
                {recordLists?.[dataCategory]?.length ? (
                  <RORDataTable
                    key={`table-${dataCategory}-${index}`}
                    headers={REVIEW_RECORD_HEADERS}
                    rows={recordLists[dataCategory] || []}
                    isCheckbox={true}
                    onDownloadAction={handleDownloadSingleFile}
                    onPagesReviewedChange={(rows) =>
                      handlePagesReviewedChange(rows, dataCategory)
                    }
                    selectedRowIds={
                      selectedRowsByCategory[dataCategory]?.map((r) => r.id) ||
                      []
                    }
                    onCheckboxSelect={(rows) =>
                      handleCheckboxSelect(dataCategory, rows)
                    }
                    isRORCompletedWithStatus={isRORCompletedWithStatus}
                  />
                ) : (
                  <div>
                    <Row>
                      <span className="no_rec_data">No Record Found</span>
                    </Row>
                  </div>
                )}
              </div>
            </>
          ),
          eventKey: index.toString(),
        }),
      )}
      activeKey={activeKeys}
      onSelect={(key) => {
        const index = parseInt(key || "0");
        const { dataCategory, keyID } = reviewRecordSummaryResult[index];
        handleAccordionToggle(key, dataCategory, keyID);
      }}
      isROR={true}
    />
  );

  const handleAccordionToggle = async (
    key: string | null,
    dataCategory: string,
    KeyID: number,
  ) => {
    if (!key) return;
    setActiveKeys((prevActiveKeys = []) => {
      if (prevActiveKeys.includes(key)) {
        return prevActiveKeys.filter((k) => k !== key);
      }

      return [...prevActiveKeys, key];
    });
    await fetchRecordListDataNew(caseInfoId, KeyID, dataCategory);
  };

  return (
    <Container fluid className="pb-5" ref={containerRef}>
      <Loader isLoading={loading} />
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />

      <UploadStatusFloatingIcon
        uploadStatuses={downloadStatuses}
        isUpload={false}
        onCancelUpload={(id: any) => {
          setDownloadStatuses((prev: any) => {
            const updated = { ...prev };
            delete updated[id];
            return updated;
          });
        }}
      />

      {recordInfoAccordion([
        {
          title: "Record Information",
          content: (
            <>
              <Row>
                {existsDocType ? (
                  <Col sm={3}>
                    <TextInput
                      label="Document Type"
                      name="documentType"
                      value={documentTypeName}
                      disabled
                      isDropdown={true}
                    />
                  </Col>
                ) : (
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Document Type"
                      name="documentType"
                      required={true}
                      options={documentTypeOptions}
                      value={documentType}
                      onChange={(e, name, value) => {
                        setDocumentType(value);
                        setComments("");
                        const selectedType = documentTypeOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedType) {
                          setDocumentCategory(
                            selectedType?.documentCategory || "",
                          );
                          setDocumentTypeDescription(
                            selectedType?.documentTypeDescription || "",
                          );
                        }
                      }}
                      disabled={result[0]?.caseRecordHeaderId}
                    />
                  </Col>
                )}

                <Col sm={3}>
                  <TextInput
                    label="Category"
                    name="documentCategory"
                    value={documentCategory}
                    disabled
                  />
                </Col>

                <Col sm={6}>
                  <TextInput
                    label="Document Type Description"
                    name="documentTypeDescription"
                    value={documentTypeDescription}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                {existsSender ? (
                  <Col sm={6}>
                    <TextInput
                      label="Sender"
                      name="sender"
                      value={senderName}
                      disabled
                      isDropdown={true}
                    />
                  </Col>
                ) : (
                  <Col sm={6} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Sender"
                      name="sender"
                      required={true}
                      options={senderOptions}
                      value={sender}
                      onChange={(e, name, value) => {
                        setSender(value);
                        const selectedCode = senderOptions?.find(
                          (item) => item.value === value,
                        );
                        if (selectedCode) {
                          setSenderCode(selectedCode?.partyCode || "");
                        }
                      }}
                      disabled={result[0]?.caseRecordHeaderId}
                    />
                  </Col>
                )}
                <Col sm={6} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Appointment Date & Time"
                    name="ADT"
                    required={true}
                    options={appointmentDateOptions}
                    value={appointmentDateTime}
                    onChange={(e, name, value) => {
                      setAppointmentDateTime(value);
                    }}
                    disabled
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col sm={12}>
                  <MultilineTextBox
                    label="Additional Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={300}
                    disabled={existsDocType}
                  />
                </Col>
              </Row>
            </>
          ),
        },
      ])}

      <>
        {" "}
        {attachmentAccordion([
          {
            title: "Attachments",
            content: (
              <>
                <Row className="align-items-center">
                  <HistorianRecordEditableTable
                    caseInfoId={caseInfoId}
                    comments={comments}
                    onFileIdsUpdate={handleFileIdsUpdate}
                    result={result}
                    isCancel={isCancel}
                    documentType={documentType}
                    isRowActionTriggered={isRowActionTriggered}
                    selectedRowData={selectedRowData}
                    recordActiveTab={recordActiveTab}
                    activeTab={activeTab}
                    isAllCancel={isAllCancel}
                    setIsAllCancel={setIsAllCancel}
                    existsDocType={existsDocType}
                    documentTypeName={documentName || documentTypeName}
                  />
                </Row>
              </>
            ),
          },
        ])}
      </>

      {(documentTypeOptions?.some((item) => item.value === documentType) ||
        documentType == null) && (
        <>
          {" "}
          {recordRORAccordion([
            {
              title: "Review of Records",
              content: (
                <>
                  {reviewRecordSummaryResult?.length ? (
                    renderAccordion()
                  ) : (
                    <div>
                      <Row>
                        <span className="no_rec_data">No Record Found</span>
                      </Row>
                    </div>
                  )}
                </>
              ),
            },
          ])}
        </>
      )}
      <Row className="mb-3 mt-3">
        <Col className="d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-center m-0"
            onClick={handleCancelButton}
            disabled={isSaveDisabled || existsDocType || isOnSaveDisable}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            className="d-flex align-items-center mx-2"
            onClick={
              isRORCompleted && isPagesReviewedChanged
                ? handleSubmitForROR
                : handleSubmit
            }
            disabled={isSaveDisabled || existsDocType || isOnSaveDisable}
          >
            <span className="material-icons mx-1">save</span> Save
          </Button>
        </Col>
      </Row>

      {selectedRowData?.caseRecordHeaderId &&
        documentTypeOptions?.some((item) => item.value === documentType) &&
        recordHistoryAccordion([
          {
            title: "Review History",
            content: (
              <>
                <Row>
                  <DataTable
                    headers={REVIEW_HISTORY_HEADERS}
                    rows={reviewHistoryResult}
                  />
                </Row>
              </>
            ),
          },
        ])}

      <Row className="mb-3 mt-3">
        <Col className="d-flex justify-content-start">
          {isEditorFile && (
            <Button
              variant="outline"
              className="d-flex align-items-center btn-text-border me-1"
              onClick={handleBack}
            >
              <span className="material-icons mr-2 ">arrow_back</span>
              Back
            </Button>
          )}
          {userData?.caseInfoId ? (
            <>
              {!isEditorFile && (
                <Button
                  variant="outline"
                  className="d-flex align-items-center btn-text-border me-1"
                  onClick={handleBack}
                >
                  <span className="material-icons mr-2 ">arrow_back</span>
                  Back
                </Button>
              )}
              {isRowActionTriggered ? (
                <OverlayTrigger
                  placement="auto"
                  overlay={
                    <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                      Logs
                    </Tooltip>
                  }
                >
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center mx-2 me-0"
                    onClick={handleOpenDrawer}
                  >
                    <span className="material-icons">description</span>
                  </button>
                </OverlayTrigger>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </Col>
      </Row>

      <OverlayDrawer
        title={"Logs"}
        open={drawerOpen}
        onClose={handleCloseDrawer}
        placement="bottom"
      >
        <DataTable
          headers={GENERAL_LOG_HEADERS}
          rows={logdata}
          isLogTable={true}
        />
      </OverlayDrawer>

      <Modal show={showModalROR} onHide={handleCloseModalROR}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to update reviewed document status?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalROR}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmRORChanges}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalNew} onHide={handleCloseModalNew}>
        <Modal.Body className="fw-bold text-left modelheading ">
          <div>Are you sure you want to cancel?</div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalNew}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            onClick={handleConfirmCancelButton}
            variant="primary"
            className="ms-3 d-flex align-items-center"
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        data-ignore-click-outside
        show={showUploadWarning}
        onHide={handleCloseModalWarning}
      >
        <Modal.Body className="fw-bold text-left modelheading">
          <div>
            Your files are currently uploading. Cancelling now will discard any
            in-progress uploads. Are you sure?
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex justify-content-end">
          <Button
            variant="outline-info"
            className="d-flex align-items-end"
            onClick={handleCloseModalWarning}
          >
            <span className="material-icons mr-2">close</span> Cancel
          </Button>
          <Button
            id="cancel-upload-button"
            variant="primary"
            className="ms-3 d-flex align-items-center"
            onClick={handleUploadInteraction}
          >
            <span className="material-icons mx-1">check</span> Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default RORUploadRecord;
